export default __webpack_public_path__ + "static/P_SearchThumb_IN-5905HD_Downloads-133cffab7e0cb989f2a3d4579df7a0c4.webp";